module.exports = __webpack_public_path__ + "media/images/beauty/card-mobile@2x-a666bb695325249209bddd570125f34c.jpg";